/** Whether a key goes into a field: an input, text area, select or editable text (like the editor). */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target.isContentEditable || !!target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])');
}

/**
 * Ctrl + K (Cmd + K on a Mac) opens the search, also from a text field, except in editable text like the editor, where
 * it adds a link. Shift + F does too, except while typing, where it is just a capital F. Keys are compared
 * case-insensitively: not every browser reports a capital with Shift held.
 */
export function isSearchShortcut(event: KeyboardEvent): boolean {
  const key = event.key?.toLowerCase();
  const controlK =
    key === 'k' &&
    (event.ctrlKey || event.metaKey) &&
    !event.shiftKey &&
    !event.altKey &&
    !(event.target instanceof HTMLElement && event.target.closest('[contenteditable]:not([contenteditable="false"])'));
  const shiftF =
    key === 'f' && event.shiftKey && !event.ctrlKey && !event.metaKey && !event.altKey && !isTypingTarget(event.target);
  return controlK || shiftF;
}

/** The search shortcut as a Mac or another computer shows it. */
export function searchShortcutLabel(platform = globalThis.navigator?.userAgent ?? ''): string {
  return /Mac|iPhone|iPad/.test(platform) ? '⌘ K' : 'Ctrl + K';
}

/** ? (or F1) opens the help, except while typing, where it is just a question mark. */
export function isHelpShortcut(event: KeyboardEvent): boolean {
  if (event.ctrlKey || event.metaKey || event.altKey) return false;
  return (event.key === '?' && !isTypingTarget(event.target)) || event.key === 'F1';
}
